
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

interface AuthorBioProps {
  author: string;
  authorRole: string;
  authorImage: string;
  authorBio: string;
}

export default function AuthorBio({
  author,
  authorRole,
  authorImage,
  authorBio,
}: AuthorBioProps) {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-12 bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div
          ref={ref}
          className={`bg-gradient-to-br from-slate-50 to-slate-100 rounded-2xl p-8 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6">
            <img
              src={authorImage}
              alt={author}
              className="w-24 h-24 rounded-full object-cover object-top border-4 border-white shadow-lg flex-shrink-0"
            />
            <div className="text-center sm:text-left">
              <p className="text-sm text-[#00989e] font-semibold uppercase tracking-wide mb-1">
                Written by
              </p>
              <h3 className="font-['Montserrat'] text-xl font-bold text-slate-800 mb-1">
                {author}
              </h3>
              <p className="text-slate-500 text-sm mb-4">{authorRole}</p>
              <p className="text-slate-600 leading-relaxed">{authorBio}</p>
              <div className="flex justify-center sm:justify-start gap-3 mt-4">
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center bg-white rounded-full text-slate-500 hover:text-[#00989e] hover:shadow-md transition-all cursor-pointer"
                >
                  <i className="ri-twitter-x-line"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 flex items-center justify-center bg-white rounded-full text-slate-500 hover:text-[#00989e] hover:shadow-md transition-all cursor-pointer"
                >
                  <i className="ri-linkedin-fill"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
